import { Button, Container } from "./Filters.styled";
import {
	ICON_INSTRUMENT_GUITAR,
	ICON_INSTRUMENT_KEYBOARD,
	ICON_INSTRUMENT_SAXOPHONE,
} from "../../../components/common/Icons";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { INSTRUMENT_NAME } from "../../../constants";
import { useEffect } from "react";
import { LocalStorage } from "../../../core";
import { useTranslation } from "react-i18next";

interface FiltersProps {}

export const Filters = observer(({}: FiltersProps) => {
	const { grandCharts } = useStores();
	const { filter, setFilter } = grandCharts;

	const { t } = useTranslation();

	useEffect(() => {
		const filterInstrument = LocalStorage.get("filterInstrument") || INSTRUMENT_NAME.GUITAR;
		setFilter(filterInstrument);
	}, []);

	return (
		<>
			<Container>
				<Button isActive={filter === INSTRUMENT_NAME.GUITAR} onClick={() => setFilter(INSTRUMENT_NAME.GUITAR)}>
					<ICON_INSTRUMENT_GUITAR /> {t("instruments.guitar")}
				</Button>
				<Button isActive={filter === INSTRUMENT_NAME.KEYBOARD} onClick={() => setFilter(INSTRUMENT_NAME.KEYBOARD)}>
					<ICON_INSTRUMENT_KEYBOARD /> {t("instruments.keyboard")}
				</Button>
				<Button isActive={filter === INSTRUMENT_NAME.SAXOPHONE} onClick={() => setFilter(INSTRUMENT_NAME.SAXOPHONE)}>
					<ICON_INSTRUMENT_SAXOPHONE /> {t("instruments.saxophone")}
				</Button>
			</Container>
		</>
	);
});
